import { render, staticRenderFns } from "./OmxBugReport.vue?vue&type=template&id=40e92996&scoped=true"
import script from "./OmxBugReport.vue?vue&type=script&lang=js"
export * from "./OmxBugReport.vue?vue&type=script&lang=js"
import style0 from "./OmxBugReport.vue?vue&type=style&index=0&id=40e92996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e92996",
  null
  
)

export default component.exports